namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_extension_app, {

		width: '100%',
		maxWidth: '100%',
		minWidth: 0,
		
		No_extension: {
			padding: '1rem',
		},
		
	} )
	
}
